export enum ServerName {
  EmployeeGraphQL = 'EmployeeGraphQL',
  GatewayGraphQL = 'GatewayGraphQL',
  ProjectGraphQL = 'ProjectGraphQL',
  RBSGraphQL = 'RBSGraphQL',
  WageGraphQL = 'WageGraphQL',
}
